<template>
	<div class="open-account-userinfo">

		<h1 class="h1_title">投资经验</h1>

		<van-form @submit="nextStep()">
			<van-field
				readonly
				clickable
				label="股票"
				label-width="80px"
				:value="formItem.stock"
				placeholder="请选择"
				@click="show1 = true"
				required
				:rules="rules.stock"
			/>
			<van-popup v-model="show1" round position="bottom">
				<van-picker
					title="请选择"
					show-toolbar
					:columns="arr1"
					value-key="name"
					@cancel="show1 = false"
					@confirm="onConfirm1"
				/>
			</van-popup>
			<van-field
				readonly
				clickable
				label="衍生权证"
				label-width="80px"
				:value="formItem.derivative_warrant"
				placeholder="请选择"
				@click="show2 = true"
				required
				:rules="rules.derivative_warrant"
			/>
			<van-popup v-model="show2" round position="bottom">
				<van-picker
					title="请选择"
					show-toolbar
					:columns="arr2"
					value-key="name"
					@cancel="show2 = false"
					@confirm="onConfirm2"
				/>
			</van-popup>
			<van-field
				readonly
				clickable
				label="股票权证"
				label-width="80px"
				:value="formItem.stock_warrant"
				placeholder="请选择"
				@click="show3 = true"
				required
				:rules="rules.stock_warrant"
			/>
			<van-popup v-model="show3" round position="bottom">
				<van-picker
					title="请选择"
					show-toolbar
					:columns="arr3"
					value-key="name"
					@cancel="show3 = false"
					@confirm="onConfirm3"
				/>
			</van-popup>
			<van-field
				readonly
				clickable
				label="期指"
				label-width="80px"
				:value="formItem.expectation_index"
				placeholder="请选择"
				@click="show4 = true"
				required
				:rules="rules.expectation_index"
			/>
			<van-popup v-model="show4" round position="bottom">
				<van-picker
					title="请选择"
					show-toolbar
					:columns="arr4"
					value-key="name"
					@cancel="show4 = false"
					@confirm="onConfirm4"
				/>
			</van-popup>
			<van-field
				readonly
				clickable
				label="期权"
				label-width="80px"
				:value="formItem.option"
				placeholder="请选择"
				@click="show5 = true"
				required
				:rules="rules.option"
			/>
			<van-popup v-model="show5" round position="bottom">
				<van-picker
					title="请选择"
					show-toolbar
					:columns="arr5"
					value-key="name"
					@cancel="show5 = false"
					@confirm="onConfirm5"
				/>
			</van-popup>
			<van-field
				readonly
				clickable
				label="互惠基金"
				label-width="80px"
				:value="formItem.mutual_fund"
				placeholder="请选择"
				@click="show6 = true"
				required
				:rules="rules.mutual_fund"
			/>
			<van-popup v-model="show6" round position="bottom">
				<van-picker
					title="请选择"
					show-toolbar
					:columns="arr6"
					value-key="name"
					@cancel="show6 = false"
					@confirm="onConfirm6"
				/>
			</van-popup>
			<van-field
				readonly
				clickable
				label="债券"
				label-width="80px"
				:value="formItem.bond"
				placeholder="请选择"
				@click="show7 = true"
				required
				:rules="rules.bond"
			/>
			<van-popup v-model="show7" round position="bottom">
				<van-picker
					title="请选择"
					show-toolbar
					:columns="arr7"
					value-key="name"
					@cancel="show7 = false"
					@confirm="onConfirm7"
				/>
			</van-popup>
			<div class="common_block">
				<van-button type="warning" block round native-type="submit">{{translate('userinfo_next_step')}}</van-button>
			</div>
		</van-form>
	</div>
</template>

<script>
	export default {
		name: 'account_invest',
		data() {
			return {
				token: "",
				
				formItem: {
					stock: "",
					derivative_warrant: "",
					stock_warrant: "",
					expectation_index: "",
					option: "",
					mutual_fund: "",
					bond: "",
				},
				rules: {
					stock: [
						{
							required: true,
							message: '请选择股票',
							trigger: 'onBlur'
						}						
					],
					derivative_warrant: [
						{
							required: true,
							message: '请选择衍生权证',
							trigger: 'onBlur'
						}						
					],
					stock_warrant: [
						{
							required: true,
							message: '请选择股票权证',
							trigger: 'onBlur'
						}						
					],
					expectation_index: [
						{
							required: true,
							message: '请选择期指',
							trigger: 'onBlur'
						}						
					],
					option: [
						{
							required: true,
							message: '请选择期权',
							trigger: 'onBlur'
						}						
					],
					mutual_fund: [
						{
							required: true,
							message: '请选择互惠基金',
							trigger: 'onBlur'
						}						
					],
					bond: [
						{
							required: true,
							message: '债券',
							trigger: 'onBlur'
						}						
					]
				},
				show1: false,
				arr1: [{name:''}],
				show2: false,
				arr2: [{name:''}],
				show3: false,
				arr3: [{name:''}],
				show4: false,
				arr4: [{name:''}],
				show5: false,
				arr5: [{name:''}],
				show6: false,
				arr6: [{name:''}],
				show7: false,
				arr7: [{name:''}],
			}
		},
		mounted() {
			if (this.$route.query.token == "" || this.$route.query.token == undefined) {
				this.$router.replace('/nologin')
			} else {
				this.token = this.$route.query.token
				this.init()
				this.getquestion(4)
			}
		},
		methods: {
			init(){
				//根据TOKEN获取信息
				this.$axios({
					method: 'post',
					url: 'account_open/info',
					data: {
						token: this.token
					}
				}).then ((res) => {
					if (res.success) {
						if (res.data.status == 2) {
							//	待审核
							this.$router.replace('/account/success')
						} else if (res.data.status == 3) {
							//	不通过
							this.$router.replace('/account/fail?token=' + this.token)
						} else {
							var data = res.data.investment_experience_data		
							if (data.length != 0) {
								this.formItem.stock=data.stock
								this.formItem.derivative_warrant=data.derivative_warrant
								this.formItem.stock_warrant=data.stock_warrant
								this.formItem.expectation_index=data.expectation_index
								this.formItem.option=data.option
								this.formItem.mutual_fund=data.mutual_fund
								this.formItem.bond=data.bond
							}
						}
					} else {
						this.$toast.fail(res.error_text)
					}
				})
			},
			getquestion(type) {
				this.$axios({
					method: 'post',
					url: 'account_open/getquestion',
					data: {
						filter_type:type
					}
				}).then ((res) => {
					if (res.success) {
						this.arr1=res.data[0].answers
						this.arr2=res.data[1].answers
						this.arr3=res.data[2].answers
						this.arr4=res.data[3].answers
						this.arr5=res.data[4].answers
						this.arr6=res.data[5].answers
						this.arr7=res.data[6].answers
					}else{
						this.$toast.fail(res.error_text)
					}
				})
			},
			
			onConfirm1(value) {
				if (value) {
					this.formItem.stock = value.name
				}
				this.show1 = false
			},
			onConfirm2(value) {
				if (value) {
					this.formItem.derivative_warrant = value.name
				}
				this.show2 = false
			},
			onConfirm3(value) {
				if (value) {
					this.formItem.stock_warrant = value.name
				}
				this.show3 = false
			},
			onConfirm4(value) {
				if (value) {
					this.formItem.expectation_index = value.name
				}
				this.show4 = false
			},
			onConfirm5(value) {
				if (value) {
					this.formItem.option = value.name
				}
				this.show5 = false
			},
			onConfirm6(value) {
				if (value) {
					this.formItem.mutual_fund = value.name
				}
				this.show6 = false
			},
			onConfirm7(value) {
				if (value) {
					this.formItem.bond = value.name
				}
				this.show7 = false
			},
			nextStep() {
				this.$axios({
					method: 'post',
					url: 'account_open/alter',
					data: {
						token: this.token,
						investment_experience_data: JSON.stringify(this.formItem)
					}
				}).then ((res) => {
					if (res.success) {
						this.$router.push('/account/statement?token=' + this.token)
					}else{
						this.$toast.fail(res.error_text)
					}
				})
			}
		},
	}
</script>